import { LAYER_KIND, rangeColors } from '../utils/configQueries'

export const setFeatures = (payload) => ({
  type: setFeatures.toString(),
  payload
})
setFeatures.toString = () => 'layers/setFeatures'

export const setGenericLayer = (payload) => ({
  type: setGenericLayer.toString(),
  payload
})
setGenericLayer.toString = () => 'layers/setGenericLayer'

export const countryChanged = (payload) => ({
  type: countryChanged.toString(),
  payload
})
countryChanged.toString = () => 'layers/countryChanged'

export const projectChanged = (payload) => ({
  type: projectChanged.toString(),
  payload
})
projectChanged.toString = () => 'layers/projectChanged'

export const priorityChanged = (payload) => ({
  type: priorityChanged.toString(),
  payload
})
priorityChanged.toString = () => 'layers/priorityChanged'

export const layerAdded = (payload) => ({
  type: layerAdded.toString(),
  payload
})
layerAdded.toString = () => 'layers/added'

export const layerUpdated = (payload) => ({
  type: layerUpdated.toString(),
  payload
})
layerUpdated.toString = () => 'layers/layerUpdated'

export const layerDeleted = (payload) => ({
  type: layerDeleted.toString(),
  payload
})
layerDeleted.toString = () => 'layers/deleted'

export const layerVisibilityChanged = (payload) => ({
  type: layerVisibilityChanged.toString(),
  payload
})
layerVisibilityChanged.toString = () => 'layers/visibilityChanged'

export const layerIcludeNameChanged = (payload) => ({
  type: layerIcludeNameChanged.toString(),
  payload
})
layerIcludeNameChanged.toString = () => 'layers/icludeNameChanged'

export const layerSliderChanged = (payload) => ({
  type: layerSliderChanged.toString(),
  payload
})
layerSliderChanged.toString = () => 'layers/sliderChanged'

export const layerButtonColors = (payload) => ({
  type: layerButtonColors.toString(),
  payload
})
layerButtonColors.toString = () => 'layers/buttonColors'

export const orderLayersChange = (payload) => ({
  type: orderLayersChange.toString(),
  payload
})
orderLayersChange.toString = () => 'layers/orderLayersChange'

export const layerIncludeValueChanged = (payload) => ({
  type: layerIncludeValueChanged.toString(),
  payload
})
layerIncludeValueChanged.toString = () => 'layers/includeValueChanged'

const reorder = (list, startIndex, endIndex) => {
  const [removed] = list.splice(startIndex, 1)
  list.splice(endIndex, 0, removed)
  return list
}

const layersReducer = {
  [setGenericLayer]: (draftState, { id, name, color, icon, style }) => {
    draftState.genericLayer.id = id
    draftState.genericLayer.name = name
    draftState.genericLayer.color = color
    draftState.genericLayer.icon = icon
    draftState.genericLayer.style = style
      ? style
      : draftState.genericLayer.style
  },
  [countryChanged]: (draftState, { country }) => {
    draftState.genericLayer.country = country
  },
  [projectChanged]: (draftState, { projectType }) => {
    draftState.genericLayer.projectType = projectType
  },
  [priorityChanged]: (draftState, { priority }) => {
    draftState.genericLayer.priority = priority
  },
  [layerAdded]: (
    draftState,
    {
      id,
      membersValues,
      metadata,
      dimensions,
      steps,
      isVisible,
      includeName,
      opacity,
      idPaint,
      includeValue,
      kind,
      statisticsVisibility,
      isCountry,
      layerType
    }
  ) => {
    if (
      !draftState.layers.find(
        ({ id: _id, membersValues: _membersValues }) => _id === id
      )
    ) {
      draftState.layers.unshift({
        id,
        kind,
        membersValues,
        metadata,
        dimensions,
        steps,
        isVisible,
        includeName,
        opacity,
        idPaint,
        includeValue,
        updated: false,
        statisticsVisibility,
        isCountry,
        layerType
      })
    } else {
      // set membersValues
      const layer = draftState.layers.find(({ id: _id }) => _id === id)
      const index = draftState.layers.indexOf(layer)
      draftState.layers[index].membersValues = membersValues
      draftState.layers[index].isVisible = true

      if (layer.kind === LAYER_KIND.EXTERNAL) layer.isVisible = false
    }
    // close the other indicator layers
    if (kind === LAYER_KIND.INDICATOR) {
      draftState.layers.forEach((draftOtherLayer) => {
        if (
          draftOtherLayer.id !== id &&
          draftOtherLayer.isVisible &&
          draftOtherLayer.kind === LAYER_KIND.INDICATOR
        ) {
          draftOtherLayer.isVisible = false
        }
      })
    }
  },
  [layerVisibilityChanged]: (draftState, { id, isVisible }) => {
    const draftLayer = draftState.layers.find(({ id: _id }) => _id === id)
    draftLayer.isVisible = isVisible
    // close the other indicator layers
    if (isVisible && draftLayer.kind === LAYER_KIND.INDICATOR) {
      draftState.layers.forEach((draftOtherLayer) => {
        if (
          draftOtherLayer.id !== id &&
          draftOtherLayer.isVisible &&
          draftOtherLayer.kind === LAYER_KIND.INDICATOR
        ) {
          draftOtherLayer.isVisible = false
        }
      })
    }
  },
  [layerDeleted]: (draftState, { id }) => {
    draftState.layers = draftState.layers.filter(({ id: _id }) => id !== _id)
  },
  [layerUpdated]: (draftState, { id, membersValues, metadata, steps }) => {
    if (membersValues) {
      draftState.layers.find(({ id: _id }) => id === _id).membersValues =
        membersValues
    }
    if (metadata) {
      draftState.layers.find(({ id: _id }) => id === _id).metadata = metadata
    }
    if (steps) {
      draftState.layers.find(({ id: _id }) => id === _id).steps = steps
    }
  },
  [layerIcludeNameChanged]: (draftState, { id, includeName }) => {
    draftState.layers.find(({ id: _id }) => _id === id).includeName =
      includeName
  },
  [layerSliderChanged]: (draftState, { id, opacity }) => {
    draftState.layers.find(({ id: _id }) => _id === id).opacity = opacity
  },
  [layerButtonColors]: (draftState, { id, idPaint }) => {
    const layer = draftState.layers.find(({ id: _id }) => _id === id)
    layer.idPaint = idPaint
    layer.steps = layer.steps.map((step, idx) =>
      idx % 2 ? step : rangeColors[idPaint][Math.floor(idx / 2)]
    )
  },
  [orderLayersChange]: (draftState, { startIndex, endIndex }) => {
    const layers = draftState.layers
    // reorder layers after drag and drop
    const layersReorder = reorder(layers, startIndex, endIndex)
    draftState.layers = layersReorder
  },
  [layerIncludeValueChanged]: (draftState, { id, includeValue }) => {
    draftState.layers.find(({ id: _id }) => _id === id).includeValue =
      includeValue
  },
  [setFeatures]: (draftState, { features }) => {
    draftState.genericLayer.features = features
  }
}

export default layersReducer
